import { render, staticRenderFns } from "./BuildingGradient.vue?vue&type=template&id=bc9f16a4"
import script from "./BuildingGradient.vue?vue&type=script&lang=js"
export * from "./BuildingGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports